import { useLocation } from 'react-router-dom';

export default function usePublicNavbar(contactUs = true) {
    const location = useLocation();

    return [
        ...(contactUs ? [{
            text: "Contact Us",
            link: "/contact-us",
        }] : []),
        {
            text: "Main Website",
            link: "https://nextgenerationfocus.org",
        },
        {
            text: "Portals",
            dropdown: true,
            items: [
                { text: "Family Portal", link: "/family-portal" },
                { text: "Staff Portal", link: "/staff-portal" },
                { text: "Admin Portal", link: "/admin-portal" },
            ].map(item => (item.disabled = location.pathname === item.link, item)),
        }
    ];
}